<template>
    <div>
        <card-header :title="component.title" icon="fa-dot-circle"/>

        <card-body>
            <render-component :component="component" class="component-content"/>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import RenderComponent from "@/components/RenderComponent";

    import {client as http} from "@/http_client";

    export default {
        components: {RenderComponent, CardBody, CardHeader},
        props: ['card', 'props'],
        data: function() {
            return {
                component: {},
                course: {},
                debug: {}
            };
        },
        methods: {
            loadComponent: function() {
                this.$emit('loading', true);
                http.get('components/' + this.props.componentId, {force: true}).then(response => {
                    this.component = response.data;
                    this.debug = JSON.parse(this.component.content);
                    this.$emit('loading', false);
                });

                http.get('courses/new/' + this.props.courseId, {force: true}).then(response => { // TODO: temporary endpoint
                    this.course = response.data;
                    this.$emit('title', this.course.title);
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
        },
        watch: {
            'props.componentId': function() {
                this.loadComponent();
            }
        },
        mounted: function() {
            this.loadComponent();
        }
    };
</script>

<style lang="scss" scoped>
    .component-content {
        margin: 2rem 0;
    }
</style>
